module.exports = __webpack_public_path__ + "media/images/logo/logo-webmoney-48cb01fada846154d36a54fe1a796b3f.svg";